export default {
  common: {
    off: 'Off',
    strong: 'Strong',
    short: 'Short',
    long: 'Long',
    leftButton: 'Left Button',
    rightButton: 'Right Button',
    leftValue: 'Left: {value}',
    rightValue: 'Right: {value}',
  },
  tabs: {
    triggerTravel: 'Actuation Travel',
    rapidTrigger: 'RT Travel',
    vibration: 'Click Feel & Feedback',
    sound: 'Click Sound & Volume',
    config: 'Button Presets',
    calibration: 'Button Calibration',
  },
  sections: {
    triggerTravel: 'Actuation Travel',
    rapidTrigger: 'RT Travel',
    vibration: 'Vibration Feedback',
    sound: 'Sound & Volume',
  },
  mode: {
    both: 'Left + Right',
    left: 'Left Button',
    right: 'Right Button',
  },
  travel: {
    differentValues: 'The left and right buttons use different actuation travel settings.',
    setValue: 'Set actuation travel to {value}',
  },
  rapidTrigger: {
    differentValues: 'The left and right buttons use different RT travel settings.',
    enable: 'Enable RT',
    setValue: 'Set RT travel to {value}',
    riskTip: 'A lower RT travel setting may increase the risk of unintended actuation.',
  },
  vibration: {
    differentValues: 'The left and right buttons use different vibration strength settings.',
    powerWarning: 'Stronger vibration feedback increases power consumption.',
    typeGroup: 'Vibration feedback type',
    feedback: 'Feedback Type',
    types: {
      mechanical: 'Mechanical-style Microswitch',
      optical: 'Optical-style Microswitch',
      electromagnetic: 'Electromagnetic Microswitch',
    },
  },
  sound: {
    label: 'Sound',
    option: 'Sound {value}',
    setVolume: 'Set volume to {value}{unit}',
  },
  volume: {
    label: 'Volume',
    option: 'Volume{value}{unit}',
  },
  restore: {
    title: 'Reset to Default',
    content:
      'The custom settings for this feature will be reset to their factory defaults. This action cannot be undone. Do you want to continue?',
  },
  presets: {
    loginRequired: 'Log in to your account to add a custom preset.',
    createTitle: 'Add Custom Preset',
    namePlaceholder: 'Enter a preset name',
    defaultUserName: 'Custom Preset',
    untitled: 'Untitled Preset',
    currentUnavailable: 'The current custom presets have not finished loading.',
    maxReached: 'You can upload up to {count} button prest.',
    uploaded: 'Custom Preset uploaded.',
    uploadFailed: 'Failed to upload the custom preset.',
    loadFailed: 'Failed to load your custom presets.',
    overwrite: 'Overwrite',
    overwriteTips: 'Overwrite the settings with the current custom preset',
    overwriteTitle: 'Overwrite Custom Preset',
    overwriteCloudConfirm: 'Overwrite “{name}” with the current custom preset?',
    overwritten: 'Custom Preset overwritten.',
    overwriteFailed: 'Failed to overwrite the custom preset.',
    renameTitle: 'Rename the Custom Preset',
    renamed: 'Custom Preset renamed',
    renameFailed: 'Failed to rename the custom preset ',
    deleteTitle: 'Delete Custom Preset',
    deleteConfirm: 'Delete “{name}”? This action cannot be undone.',
    deleted: 'Custom Preset deleted.',
    deleteFailed: 'Failed to delete the custom preset.',
    names: {
      official1: 'Official Preset 1',
      official2: 'Official Preset 2',
      official3: 'Official Preset 3',
    },
    applyTitle: 'Apply {name}',
    applyPreset: 'Apply Preset',
    overwriteConfirm:
      'Applying this preset will overwrite the button trigger settings in the current profile. Continue?',
    applying: 'Applying...',
    confirmApply: 'Apply',
    applied: '{name} applied',
    applyFailed: 'Failed to apply {name}. Please try again.',
  },
  calibration: {
    instructions: {
      hold: 'Press and hold the left/right mouse button. ',
      success: 'The button turns green when calibration succeeds',
      simultaneous: ' (both buttons can be pressed at the same time). ',
      save: 'When finished, click Save Calibration.',
    },
    entering: 'Starting...',
    saving: 'Saving...',
    cancelling: 'Cancelling...',
    saveCalibration: 'Save Calibration',
    cancelCalibration: 'Cancel Calibration',
    startCalibration: 'Start Calibration',
    passed: 'Calibrated',
    calibrating: 'Calibrating',
    waiting: 'Waiting for Input',
    notStarted: 'Not Started',
    saved: 'Calibration data saved',
  },
  errors: {
    configNotSupported: 'This device does not support RT configuration.',
    calibrationNotSupported: 'This device does not support RT calibration.',
    enterCalibrationFailed: 'Failed to start calibration.',
    saveCalibrationFailed: 'Failed to save calibration data.',
  },
}
